//Init our app
var Dafi = Dafi || {};

Dafi.Controller = Dafi.Controller || {};
Dafi.View = Dafi.View || {};
Dafi.Helper = Dafi.Helper || {};